import * as React from 'react';
import {IVideo} from '../../../service/contentServer';

export function getVideoComponentFromVideoData(video: IVideo, className: string) {
  if (video) {
    const id = video.id;
    if (video.playerType === 'iframe' || video.playerType === 'embed') {
      return <div key={`video-${id}`} className={className}>
        <iframe src={video.url} style={{width: '100%', border: 'none', height: '250px'}}/>
      </div>;
    } else if (video.playerType === 'video') {
      return <video className={className} key={`video-${id}`} controls
                    src={video.url} style={{width: '100%'}} poster={video.coverUrl || video.thumbUrl}/>;
    } else {
      return <a key={`video-${id}`} href={video.url}>{video.url}</a>;
    }
  } else {
    return null;
  }
}
